"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/ChatSearchPane/ChatSearchResultItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);






var _sender = require('shared/services/sender');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _MessageAvatar = require('web/components/Avatar/MessageAvatar'); var _MessageAvatar2 = _interopRequireDefault(_MessageAvatar);

























const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

 const emphasizeQuery = (text, query) => {
  const tokens = query.trim().split(/\s+/).filter(Boolean).map(escapeRegExp)
  if (!tokens.length) return text
  const matcher = new RegExp(`(${tokens.join('|')})`, 'gi')
  return text.split(matcher).map((part, index) =>
    index % 2 === 1
      ? _react2.default.createElement('mark', { key: `${part}-${index}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}, part)
      : part,
  )
}; exports.emphasizeQuery = emphasizeQuery

const ChatSearchResultItem = ({
  result,
  query,
  conversationType,
  conversationKey,
  blobjectKey,
  onActivate,
  myUserKey,
  active = false,
}) => {
  const handleClick = () => {
    _actions2.default.gotoBlobject(
      conversationType,
      conversationKey,
      blobjectKey,
      result.MessageKey,
    )
    onActivate(result)
  }

  const hasSender = result.SenderRemoved !== undefined
  const senderName = result.SenderKey === myUserKey
    ? 'You'
    : result.SenderName || 'Unknown sender'

  return (
    _react2.default.createElement('button', {
      className: active ? 'chat-search--result chat-search--result---active' : 'chat-search--result',
      type: "button",
      'aria-current': active || undefined,
      onClick: handleClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}

      , hasSender && (
        _react2.default.createElement(_MessageAvatar2.default, {
          className: "chat-search--result-avatar",
          size: 32,
          senderKey: _nullishCoalesce(result.SenderKey, () => ( ('' ))),
          senderType: _nullishCoalesce(result.SenderType, () => ( '')),
          profilePicture: _nullishCoalesce(result.SenderAvatar, () => ( '')), __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
        )
      )
      , _react2.default.createElement('span', { className: "chat-search--result-content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
        , _react2.default.createElement('span', { className: "chat-search--result-heading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
          , _react2.default.createElement('img', {
            src: result.resultType === 'file'
              ? '/assets/icons/search/file-purple.svg'
              : '/assets/icons/search/message-purple.svg',
            alt: result.resultType === 'file' ? 'File' : 'Message', __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
          )
          , _react2.default.createElement('span', { className: "chat-search--result-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
            , hasSender ? senderName : result.Title
          )
          , hasSender && _sender.isApiKeySender.call(void 0, result.SenderType) && (
            _react2.default.createElement('span', { className: "chat-search--result-api-marker", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}, _sender.API_KEY_SENDER_MARKER)
          )
          , result.SenderRemoved && (
            _react2.default.createElement('span', { className: "chat-search--result-removed", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}, "removed")
          )
          , _react2.default.createElement('time', { dateTime: result.TimeStamp, __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}, _moment2.default.call(void 0, result.TimeStamp).format('MMM D, YYYY'))
        )
        , _react2.default.createElement('span', { className: "chat-search--result-snippet", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
          , exports.emphasizeQuery.call(void 0, result.Subtitle, query)
        )
      )
    )
  )
}

exports. default = ChatSearchResultItem
